<template>
  <div class="chart">
    <div class="heaer-text">自定义报表</div>
    <div style="overflow: hidden">
      <allreport-filter @showLoading="showLoading" @downloadFile="downloadFile"></allreport-filter>
    </div>
    <div class="table-wrap">
      <allreport-table
        :list="list"
        :column="column"
        :loading="loading"
        ref="usertable"
        @computTotalColumn="computTotalColumn"
        :totalColumn="totalColumn"
        @openModal="openModal"
      ></allreport-table>
    </div>
    <el-dialog :title="titleModal" :visible.sync="dialogVisible" width="1200px">
      <ChartsModal :dataList="dataList"></ChartsModal>
    </el-dialog>
  </div>
</template>

<script>
import AllreportFilter from "./allreportFilter";
import AllreportTable from "./allreportTable";
import { allreport_table_column_bak } from "../../config/table_comlun";
import ChartsModal from "./chartsModal.vue";
export default {
  name: "allreportbak",
  data() {
    return {
      column: allreport_table_column_bak,
      loading: true,
      totalColumn: [],
      dialogVisible: false,
      dataList: [],
      titleModal: "",
    };
  },
  computed: {
    list: function () {
      return this.$store.state.Allreport.allreportList;
    },
  },
  components: {
    AllreportFilter,
    AllreportTable,
    ChartsModal,
  },
  mounted() {
  },
  methods: {
    showLoading(value) {
      this.loading = value;
    },
    downloadFile() {
      this.$refs.usertable.downLoadFileToExcel();
    },
    computTotalColumn(arr) {
      this.totalColumn = arr;
    },
    openModal(data, row) {
      this.dataList = data;
      this.titleModal = row.appName;
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang="less" scoped>
.heaer-text {
  padding: 16px 16px 6px 16px;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: bold;
}
.table-wrap {
  padding: 15px;
}
.el-dialog__body {
  padding: 0px;
}
</style>
